<template>
  <div class="supplier body">
    <el-container>
      <!-- <PayAside /> -->

      <el-main>
        <el-row class="search" :gutter="10">
          <el-col :span="14">
            <div class="bg-white">
              <label for="searchForCustomer">اختر اسم المورد</label>
              <el-input v-model="search" placeholder="بحث الموردين"> </el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-white">
              <label for="balnceFrom">المديونيه من</label>
              <el-input
                v-model="balnceFrom"
                type="number"
                placeholder="حساب المورد"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-white">
              <label for="balnceTo">المديونيه الي</label>
              <el-input
                v-model="balnceTo"
                type="number"
                placeholder="حساب المورد"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="2">
            <el-button
              type="success"
              title="طباعه"
              icon="el-icon-printer"
              @click="sendToPrintAll()"
              class="mt-5"
            ></el-button>
          </el-col>
        </el-row>
        <el-row class="cInfo">
          <el-col :span="24">
            <div class="bg-white">
              <div class="headerSide bg-red">
                <p class="text">حركه الموردين / حركه الدائنين</p>
                <p class="num">
                  <span>{{ numberToFixed(totalAccounts) }}</span> ج.م
                </p>
              </div>
              <div class="content">
                <Supplier :suppliers="suppliers" :btnColor="'bgRed'" />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import PayAside from "@/components/PayAside.vue";
import Supplier from "@/components/Pay/Suppliers.vue";
// import Supplier from "@/components/Pay/SuppliersCopy.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  components: { Supplier },
  data() {
    return {
      search: "",
      totalAccounts: 0,
      suppliers: [],
      allSuppliers: [],
      balnceFrom: "",
      balnceTo: "",
    };
  },
  created() {
    this.getSuppliers();
  },
  watch: {
    search: function (newValue) {
      this.suppliers = this.allSuppliers;

      let query = newValue.trim();
      if (query != "") {
        this.suppliers = this.suppliers.filter((supplier) => {
          return (
            supplier.name.toLowerCase().includes(query.toLowerCase()) ||
            (supplier.phone &&
              supplier.phone.toLowerCase().includes(query.toLowerCase()))
          );
        });
      } else {
        this.suppliers = this.allSuppliers;
      }
      this.calcTotalAcounts();
    },
    balnceFrom: function (newValue) {
      this.suppliers = this.allSuppliers;
      let balance = newValue.trim();
      if (balance != "") {
        this.suppliers = this.suppliers.filter((supplier) => {
          return (
            Number(supplier.account) + Number(supplier.balance) >=
              Number(balance) &&
            Number(supplier.account) + Number(supplier.balance) >=
              Number(this.balnceTo)
          );
        });
      } else {
        this.suppliers = this.allSuppliers;
      }
      this.calcTotalAcounts();
    },
    balnceTo: function (newValue) {
      this.suppliers = this.allSuppliers;
      let balance = newValue.trim();
      if (balance != "") {
        this.suppliers = this.suppliers.filter((supplier) => {
          return (
            Number(supplier.account) + Number(supplier.balance) <=
              Number(balance) &&
            Number(supplier.account) + Number(supplier.balance) >=
              Number(this.balnceFrom)
          );
        });
      } else {
        this.suppliers = this.allSuppliers;
      }
      this.calcTotalAcounts();
    },
  },
  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getSuppliers() {
      // suppliers/to-pay
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `suppliers-balance`;
      axiosApi
        .get(url)
        .then((response) => {
          this.suppliers = response.data;
          this.allSuppliers = response.data;
          this.calcTotalAcounts();
          setTimeout(() => {
            document.querySelector(".paied").focus();
          }, 200);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    calcTotalAcounts() {
      let sum = 0;
      this.suppliers.map((supplier) => {
        supplier["paied"] = "";
        sum += Number(supplier["balance"]) + Number(supplier["account"]);
      });
      this.totalAccounts = sum;
    },
    sendToPrintAll() {
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: { customers: this.suppliers, totalAccounts: this.totalAccounts },
      //   type: "CustomerTraffic",
      //   customer: false,
      //   title: "كشف حساب الموردين",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
  },
};
</script>
<style lang="sass">
@import "../../styles/Pay.scss"
</style>
